var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDiagRasterDisabled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "button/raster/diabled") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "button/raster/diabled",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(4.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.82756387,14.0107179",
    id: "Path-2",
    stroke: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.82756387,14.0107179",
    id: "Path-2",
    stroke: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5104076,2.48959236 C17.8298641,5.80904884 17.8298641,11.1909512 14.5104076,14.5104076 C14.3151455,14.7056698 13.998563,14.7056698 13.8033009,14.5104076 C13.6080387,14.3151455 13.6080387,13.998563 13.8033009,13.8033009 C16.732233,10.8743687 16.732233,6.12563133 13.8033009,3.19669914 C10.8743687,0.267766953 6.12563133,0.267766953 3.19669914,3.19669914 C0.351698804,6.04169948 0.270172115,10.6037022 2.95211907,13.5471078 L8.25802965,8.2410377 L8.32727754,8.18318225 C8.52214568,8.0481862 8.79157008,8.06747135 8.96513643,8.2410377 C9.16039858,8.43629985 9.16039858,8.75288234 8.96513643,8.94814448 L8.96513643,8.94814448 L1.18696184,16.7263191 L1.11771395,16.7841745 C0.922845808,16.9191706 0.653421407,16.8998854 0.479855055,16.7263191 C0.28459291,16.5310569 0.28459291,16.2144744 0.479855055,16.0192123 L0.479855055,16.0192123 L2.24454726,14.2551397 C-0.827748728,10.9205416 -0.746067027,5.72525175 2.48959236,2.48959236 C5.80904884,-0.82986412 11.1909512,-0.82986412 14.5104076,2.48959236 Z",
    id: "Combined-Shape",
    fill: "#B1B1B1",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-22",
    fill: "#B1B1B1",
    cx: 8.5,
    cy: 8.5,
    r: 3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDiagRasterDisabled);
export default __webpack_public_path__ + "static/media/icon_diag_raster_disabled.ffe346a7c817aff82efbe928c972da94.svg";
export { ForwardRef as ReactComponent };